import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import Form, { FormProps } from '@/components/Form';
import useFile from '@/modules/tasks/views/TasksDashboard/hooks/useFile';

import { FORM_LAYOUT, getFormFields, validateForm } from './config';
import { getInitialValues, ListEditorFormValues } from './config';

function Editor({
  setFormikSubmit,
  onSubmit,
  file,
  initialValues,
}: {
  setFormikSubmit: FormProps<ListEditorFormValues>['setSubmitRef'];
  onSubmit: FormProps<ListEditorFormValues>['onSubmit'];
  /**
   * used to pre-fill the edit file form
   */
  file?: ReturnType<typeof useFile>['file'];
  /**
   * used to pre-fill the form when creating a new file
   */
  initialValues?: Partial<ListEditorFormValues>;
}) {
  const { t } = useTranslation(['Admin', 'Task']);

  return (
    <Form<ListEditorFormValues>
      fields={getFormFields(t)}
      formName="ListEditor"
      initialValues={getInitialValues(file, initialValues)}
      layout={FORM_LAYOUT}
      setSubmitRef={setFormikSubmit}
      validate={validateForm(t)}
      onSubmit={onSubmit}
    />
  );
}

export default Editor;
